import * as React from 'react';
import {useContext} from 'react';
import {Box, Button, Icon, IconButton, Tooltip} from "@mui/material";
import PropTypes from "prop-types";
import {LanguageContext} from "../../context/LanguageContext";
import {useSnackbar} from "notistack";
import Rendered from "../Rendered";
import {CompanyEnvironmentContext} from "../../context/CompanyEnvironmentContext";

function ContactInfo({mobileView, appBar}) {
  const languageContext = useContext(LanguageContext);
  const companyEnvironmentContext = useContext(CompanyEnvironmentContext);
  const {enqueueSnackbar} = useSnackbar();

  const handleClick = (text) => {
    navigator.clipboard.writeText(text);
    enqueueSnackbar(languageContext.dictionary.clipboardCopySuccessful, {variant: "success"});
  };

  const menuItems = [
    {
      key: "phoneNumber",
      title: companyEnvironmentContext.contact.phoneNumber,
      onClick: () => handleClick(companyEnvironmentContext.contact.phoneNumber),
      icon: "local_phone"
    },
    ...(!mobileView ? [
      {
        key: "foreignPhoneNumber",
        title: companyEnvironmentContext.contact.foreignPhoneNumber,
        onClick: () => handleClick(companyEnvironmentContext.contact.foreignPhoneNumber),
        icon: "local_phone"
      }
    ] : []),
    {
      key: "mail",
      title: companyEnvironmentContext.contact.mail,
      onClick: () => handleClick(companyEnvironmentContext.contact.mail),
      icon: "email"
    }
  ];

  return (
    <Box sx={{display: "flex", padding: 0, alignItems: "center", bottom: 0}}>
      <Rendered rendered={!!mobileView}>
        <Box sx={{display: "flex", textAlign: "center", justifyContent: "center", alignItems: "center"}}>
          {menuItems.map(menuItem => (
            <Rendered rendered={!!menuItem.title} key={menuItem.key}>
              <Tooltip arrow title={menuItem.title} placement={"top"}>
                <IconButton onClick={menuItem.onClick}>
                  <Icon sx={{color: "secondary.main"}}>{menuItem.icon}</Icon>
                </IconButton>
              </Tooltip>
            </Rendered>
          ))}
        </Box>
      </Rendered>
      <Rendered rendered={!!appBar}>
        <Box sx={{display: "flex", justifyContent: "right", alignItems: "center"}}>
          {menuItems.map((menuItem, index) => (
            <Rendered rendered={!!menuItem.title} key={menuItem.key}>
              <Box sx={{paddingRight: (menuItems.filter(m => !!m.title)?.length - 1 === index) ? 0 : 2, paddingLeft: 2}}>
                <Button
                  size="small"
                  variant="text"
                  startIcon={<Icon>{menuItem.icon}</Icon>}
                  onClick={menuItem.onClick}
                  sx={{
                    textTransform: 'none',
                    color: "primary.soft",
                    fontWeight: "bold",
                    "&:hover": {color: "secondary.main"}
                  }}
                >
                  {menuItem.title}
                </Button>
              </Box>
            </Rendered>
          ))}
        </Box>
      </Rendered>
    </Box>
  );
}

ContactInfo.propTypes = {
  mobileView: PropTypes.bool,
  appBar: PropTypes.bool
};

export default ContactInfo;
